import { BookMarked, ScrollText, Link2, Accessibility } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: BookMarked, label: "Faithful to Catholic teaching" },
  { icon: ScrollText, label: "Church documents & Scripture" },
  { icon: Link2, label: "Clearly cited sources" },
  { icon: Accessibility, label: "Prayerful & accessible" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-source-strip" className="bg-midnight py-5">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-10 gap-y-3 px-4 sm:px-8 lg:px-16">
        {ITEMS.map((item, i) => (
          <Reveal key={item.label} delay={i * 0.08} y={14}>
            <span className="flex items-center gap-2.5 text-[13px] font-medium tracking-wide text-ivory/85">
              <item.icon className="h-4 w-4 text-gold" strokeWidth={1.7} aria-hidden="true" />
              {item.label}
            </span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
